import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom"; //make sure to import all the components.
import "./settingSideNav.scss";
import Translated from "../../components/Translated/Translated";

export class SettingsSideNav extends Component {
	static propTypes = {
		prop: PropTypes
	};

	increaseZIndex = async () => {
		console.log("hello world");
	};

	render() {
		return (
			<div class="settings-side-nav">
				<h3 class="settings-side-nav-header"><Translated section="Admin Menu" label="profile_title" /></h3>
				<ul onClick={this.increaseZIndex} class="settings-side-nav-list">
					<NavLink to="/settings/user_profile">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button">
								<Translated section="Admin Menu" label="profile_title" />
							</button>
						</li>
					</NavLink>
					<NavLink to="/settings/application_settings">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button-application-settings">
								<Translated section="Admin Menu" label="application_settings_title" />
							</button>
						</li>
					</NavLink>
					<NavLink to="/settings/default_project">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button-default-project">
								<Translated section="Admin Menu" label="default_project" />
							</button>
						</li>
					</NavLink>
				</ul>
				<h3 class="settings-side-nav-header"><Translated section="Admin Menu" label="customer_section_title" /></h3>
				<ul class="settings-side-nav-list">
					<NavLink to="/settings/pricing">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button">
								<Translated section="Admin Menu" label="pricing_title" />
							</button>
						</li>
					</NavLink>
					<NavLink to="/settings/picturebook-customer-settings">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button">
								<Translated section="Admin menu" label="picturebook_title" />
							</button>
						</li>
					</NavLink>
				</ul>
				<h3 class="settings-side-nav-header"><Translated section="Admin Menu" label="warehouse_section_title" /></h3>
				<ul class="settings-side-nav-list">
					<NavLink to="/settings/product-groups">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button-product-groups">
								<Translated section="Admin Menu" label="product_groups" />
							</button>
						</li>
					</NavLink>
					<NavLink to="/settings/picturebook-warehouse-settings">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button">
								<Translated section="Admin menu" label="picturebook_title" />
							</button>
						</li>
					</NavLink>
					<NavLink to="/settings/reports">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button">
								<Translated section="Admin Menu" label="reports" />
							</button>
						</li>
					</NavLink>
					<NavLink to="/settings/room-titles">
						<li>
							<button type="button" class="btn btn-outline-primary settings-side-nav-button">
								<Translated section="Admin Menu" label="room_titles" />
							</button>
						</li>
					</NavLink>
				</ul>
				{localStorage.getItem("perm_extra_project_filters") &&
					<>
						<h3 class="settings-side-nav-header"><Translated section="Admin Menu" label="project_section_title" /></h3>
						<ul class="settings-side-nav-list">
							<NavLink to="/settings/transfer-project">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button-transfer-project">
										<Translated section="Admin Menu" label="project_transfer_title" />
									</button>
								</li>
							</NavLink>
							<NavLink to="/settings/delete-project">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button-delete-project">
										<Translated section="Admin Menu" label="project_delete_title" />
									</button>
								</li>
							</NavLink>
						</ul>
						<h3 class="settings-side-nav-header"><Translated section="Admin Menu" label="global_section_title" /></h3>
						<ul class="settings-side-nav-list">
							<NavLink to="/settings/edit-consultant">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button">
										<Translated section="Admin Menu" label="consultants" />
									</button>
								</li>
							</NavLink>
							<NavLink to="/settings/regions">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button">
										<Translated section="Admin Menu" label="regions" />
									</button>
								</li>
							</NavLink>
							<NavLink to="/settings/warehouses">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button">
										<Translated section="Admin Menu" label="warehouses" />
									</button>
								</li>
							</NavLink>
							<NavLink to="/settings/translations">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button">
										<Translated section="Admin Menu" label="translations_title" />
									</button>
								</li>
							</NavLink>
							<NavLink to="/settings/dashboard">
								<li>
									<button type="button" class="btn btn-outline-primary settings-side-nav-button">
										<Translated section="Admin Menu" label="dashboard_title" />
									</button>
								</li>
							</NavLink>
						</ul>
					</>
				}
			</div>
		);
	}
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SettingsSideNav);
